import axios from 'axios/index';

export const GET_PENGGUNA = '[PENGGUNA] GET PENGGUNA';
export const GET_PENGGUNA_MENGERJAKAN = '[PENGGUNA] GET PENGGUNA MENGERJAKAN';
export const SET_PENGGUNA = '[PENGGUNA] SET PENGGUNA';
export const HAPUS_PENGGUNA = '[PENGGUNA] HAPUS PENGGUNA';
export const TUKAR_PENGGUNA = '[PENGGUNA] TUKAR PENGGUNA';
export const GET_PERAN = '[PENGGUNA] GET PERAN';
export const TOGGLE_FORM_PENGGUNA = '[PENGGUNA] TOGGLE FORM PENGGUNA';
export const GET_LOG_LOGIN = '[PENGGUNA] GET LOG LOGIN';
export const GET_LOG_SIMPAN_JAWABAN = '[PENGGUNA] GET LOG SIMPAN JAWABAN';
export const GET_BADGE_PENGGUNA = '[PENGGUNA] GET BADGE PENGGUNA';
export const SET_BADGE_PENGGUNA = '[PENGGUNA] SET BADGE PENGGUNA';
export const GET_SEMUA_BADGE = '[PENGGUNA] GET SEMUA BADGE';
export const SET_KANDIDAT = '[PENGGUNA] SET KANDIDAT';
export const GET_PESERTA_DIDIK_DAPODIK = '[PENGGUNA] GET PESERTA DIDIK DAPODIK';
export const SALIN_PESERTA_DIDIK = '[PENGGUNA] SALIN PESERTA DIDIK';
export const GET_PTK_DAPODIK = '[PENGGUNA] GET PTK DAPODIK';
export const HAPUS_PENGGUNA_GANDA = '[PENGGUNA] HAPUS PENGGUNA GANDA';

export function setKandidat(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/setKandidat', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : SET_KANDIDAT,
                payload: response.data,
                routeParams
            })
        });
}

export function hapusPenggunaGanda(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/hapusPenggunaGanda', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : HAPUS_PENGGUNA_GANDA,
                payload: response.data,
                routeParams
            })
        });
}

export function getPengguna(routeParams)
{
    let paramPenggunaId = '';
    if(routeParams.pengguna_id !== null){
        paramPenggunaId = '/'+routeParams.pengguna_id
    }

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/pengguna'+paramPenggunaId, {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_PENGGUNA,
                payload: response.data,
                routeParams
            })
        });
}

export function getPeran(routeParams)
{
    let peran_id = '';
    if(routeParams.peran_id !== null){
        peran_id = '/'+routeParams.peran_id
    }

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/Peran'+peran_id, {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_PERAN,
                payload: response.data,
                routeParams
            })
        });
}

export function tukarPengguna(routeParams)
{
    
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/tukarPengguna', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : TUKAR_PENGGUNA,
                payload: response.data,
                routeParams
            })
        });
}

export function toggleFormPengguna(toggle, title){
    return (dispatch) => {
        return dispatch ({
            type: TOGGLE_FORM_PENGGUNA,
            toggle_form_pengguna: {
                toggle: toggle,
                title: title
            }
        })
    }
}

export function getLogLogin(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/LogLogin', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_LOG_LOGIN,
                payload: response.data,
                routeParams
            })
        });
}

export function getLogSimpanJawaban(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/LogSimpanJawaban', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_LOG_SIMPAN_JAWABAN,
                payload: response.data,
                routeParams
            })
        });
}

export function getBadgePengguna(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/BadgePengguna', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_BADGE_PENGGUNA,
                payload: response.data,
                routeParams
            })
        });
}

export function getSemuaBadge(routeParams)
{
    
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/cekSemuaBadge', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_SEMUA_BADGE,
                payload: response.data,
                routeParams
            })
        });
}

export function setBadgePengguna(routeParams, jenis_badge_id)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/BadgePengguna', {
        token: localStorage.getItem('jwt_token'),
        jenis_badge_id: jenis_badge_id,
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : SET_BADGE_PENGGUNA,
                hasil_badge_pengguna: response.data,
                routeParams
            })
        });
}

export function setPengguna(routeParams, jenis_badge_id)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/pengguna', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : SET_PENGGUNA,
                hasil_pengguna: response.data,
                routeParams
            })
        });
}

export function hapusPengguna(pengguna_id)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.delete(baseUrl + '/api/pengguna/'+pengguna_id, {
        token: localStorage.getItem('jwt_token')
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : HAPUS_PENGGUNA,
                hasil_hapus_pengguna: response.data
            })
        });
}

export function getPesertaDidikDapodik(routeParams)
{
    
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/getPesertaDidikDapodik', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_PESERTA_DIDIK_DAPODIK,
                payload: response.data,
                routeParams
            })
        });
}

export function salinPesertaDidik(routeParams)
{
    
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/salinPengguna', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : SALIN_PESERTA_DIDIK,
                payload: response.data,
                routeParams
            })
        });
}

export function getPtkDapodik(routeParams)
{
    
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/getPtkDapodik', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_PTK_DAPODIK,
                payload: response.data,
                routeParams
            })
        });
}


export function getPenggunaMengerjakan(routeParams)
{
    let paramPenggunaId = '';
    if(routeParams.pengguna_id !== null){
        paramPenggunaId = '/'+routeParams.pengguna_id
    }

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/getPenggunaMengerjakan'+paramPenggunaId, {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_PENGGUNA_MENGERJAKAN,
                payload: response.data,
                routeParams
            })
        });
}


// WEBPACK FOOTER //
// ./src/store/actions/Pengguna.actions.js